import React from 'react';
import { EntityContext } from 'nekst-api';
import ContextChip from './ContextChip';
import styles from '../ChatWidget.module.scss';

interface ContextChipListProps {
  context: EntityContext[];
  onRemove?: (context: EntityContext) => void;
}

export default function ContextChipList(props: ContextChipListProps) {
  const { context, onRemove } = props;

  if (context.length === 0) {
    return null;
  }

  return (
    <div className={styles.contextChipList}>
      {context.map((ctx) => (
        <ContextChip
          key={`${ctx.type}-${ctx.id}`}
          context={ctx}
          onRemove={onRemove ? () => onRemove(ctx) : undefined}
        />
      ))}
    </div>
  );
}
